import apiClient from './apiClient';

const API_URL = '/gastos-medicos';

// 🔹 Crear gasto médico
export const crearGastoMedico = async (gastoMedico) => {
    const response = await apiClient.post(API_URL, gastoMedico);
    return response.data;
};

// 🔹 Listar todos los gastos médicos
export const listarGastosMedicos = async () => {
    const response = await apiClient.get(API_URL);
    return response.data;
};

// 🔹 Obtener gasto médico por ID
export const obtenerGastoMedicoPorId = async (idGastomedico) => {
    const response = await apiClient.get(`${API_URL}/${idGastomedico}`);
    return response.data;
};

// 🔹 Actualizar gasto médico
export const actualizarGastoMedico = async (idGastomedico, gastoMedicoActualizado) => {
    const response = await apiClient.put(`${API_URL}/${idGastomedico}`, gastoMedicoActualizado);
    return response.data;
};

// 🔹 Eliminar gasto médico
export const eliminarGastoMedico = async (idGastomedico) => {
    const response = await apiClient.delete(`${API_URL}/${idGastomedico}`);
    return response.data;
};

// 🔹 Obtener gastos por médico
export const obtenerGastosPorMedico = async (idMedico) => {
    const response = await apiClient.get(`${API_URL}/medico/${idMedico}`);
    return response.data;
};

// 🔹 Obtener gastos por trámite
export const obtenerGastosPorTramite = async (idTramite) => {
    const response = await apiClient.get(`${API_URL}/tramite/${idTramite}`);
    return response.data;
};

// 🔹 Obtener gastos por rango de fechas
export const obtenerGastosPorFechas = async (fechaInicio, fechaFin) => {
    const response = await apiClient.get(`${API_URL}/fechas`, {
        params: {
            fechaInicio: fechaInicio,
            fechaFin: fechaFin
        }
    });
    return response.data;
};

// 🔹 Obtener gastos por monto mínimo
export const obtenerGastosPorMontoMinimo = async (montoMinimo) => {
    const response = await apiClient.get(`${API_URL}/monto`, {
        params: {
            monto: montoMinimo
        }
    });
    return response.data;
};

// 🔹 Obtener total de gastos
export const obtenerTotalGastos = async () => {
    const response = await apiClient.get(`${API_URL}/total`);
    return response.data;
};

// 🔹 Buscar gastos con filtros combinados (opcional)
export const buscarGastosConFiltros = async (filtros = {}) => {
    const { idMedico, idTramite, fechaInicio, fechaFin, montoMinimo } = filtros;

    let url = API_URL;
    const params = [];

    if (idMedico) params.push(`idMedico=${idMedico}`);
    if (idTramite) params.push(`idTramite=${idTramite}`);
    if (fechaInicio) params.push(`fechaInicio=${fechaInicio}`);
    if (fechaFin) params.push(`fechaFin=${fechaFin}`);
    if (montoMinimo) params.push(`montoMinimo=${montoMinimo}`);

    if (params.length > 0) {
        url += `/buscar?${params.join('&')}`;
    }

    const response = await apiClient.get(url);
    return response.data;
};